import { Flex } from '@chakra-ui/react';
import { Rabbit } from 'lucide-react';
import { FC } from 'react';
import { ContactUsLink } from '~/common/components/ContactUsLink';
import { CardEmptyState } from '../../../CardEmptyState';

export const LimitedDataErrorState: FC = () => {
  return (
    <Flex h="100%" justifyContent="center" w="100%">
      <CardEmptyState
        description={
          <>
            There isn't enough market data available for this specific area to
            generate a complete listing report at this time. <br />
            We're working on it! <ContactUsLink /> if you'd like to help us out.
          </>
        }
        icon={Rabbit}
        title="Limited Market Data"
      />
    </Flex>
  );
};
